import React from "react"
import { Layout } from "../components/Layout"
import { ContentBlock } from "../features/customer-service-policy-page/ui"
import SEO from "../components/SEO"
import { useLocationData } from "../hooks/locationHook"

const CustomerServicePolicy = ({ location }) => {
  useLocationData(location.pathname)

  return (
    <Layout>
      <SEO>
        <title>お客様対応基本方針｜フランソア</title>
      </SEO>
      <ContentBlock />
    </Layout>
  )
}

export default CustomerServicePolicy
